import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables.js";
import "datatables.net-responsive-dt/js/responsive.dataTables.js";
import "datatables.net-buttons/js/dataTables.buttons.min.js";
import "datatables.net-buttons/js/buttons.html5.min.js";
import "datatables.net-buttons/js/buttons.print.min.js";
import { Button, Offcanvas, Form, Row, Col, Modal } from "react-bootstrap";
import axios from "axios";
import { API_URL_LOCAL } from "..";
import { Icon } from "@iconify/react/dist/iconify.js";

const WorkSchedulesPage = () => {
  const tableRef = useRef(null);
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [scheduleToDelete, setScheduleToDelete] = useState(null);
  const [locations, setLocations] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [individuals, setIndividuals] = useState([]);

  // Fetch schedules and related data
  const fetchData = async (passed = null) => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user || !user.id) throw new Error("User not found in localStorage");

      // Fetch schedules
      const schedResponse = await axios.get(`${API_URL_LOCAL}/api/work-schedule/org/${user.id}`);
      setSchedules(schedResponse.data || []);
       
      // Fetch locations, departments, individuals for edit form
      
      const locResponse = await axios.get(`${API_URL_LOCAL}/api/company/fetch/${user.id}`);
      setLocations(locResponse.data.companies || []);

      const depResponse = await axios.get(`${API_URL_LOCAL}/api/departments/fetch/${user.id}`);
      setDepartments(depResponse.data.departments || []);

      // const indResponse = await axios.get(`${API_URL_LOCAL}/api/employees/fetch/${user.id}`);
      // setIndividuals(indResponse.data.employees || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  // Initialize DataTable
  useEffect(() => {
    if (!schedules.length || !tableRef.current) return;

    const table = $(tableRef.current).DataTable({
      data: schedules,

      columns: [
        { title: "Schedule Name", data: "schedule_name" },
        { title: "Type", data: "type" },
        {
          title: "Actions",
          data: null,
          render: (data, type, row) => `
            <button class="btn btn-sm btn-primary edit-btn" data-id="${row.id}">Edit</button>
            <button class="btn btn-sm btn-danger delete-btn ms-2" data-id="${row.id}">Delete</button>
          `,
          orderable: false,
        },
      ],
      responsive: true,
      destroy: true,
    });

    // Handle Edit and Delete button clicks
    $(tableRef.current).on("click", ".edit-btn", async function () {
      const id = $(this).data("id");
      
      try {
        const response = await axios.get(`${API_URL_LOCAL}/api/work-schedule/${id}`);
        const schedule = response.data;
        // console.log(schedule);
        // return false;  
        setSelectedSchedule({
          id: schedule.id,
          name: schedule.schedule_name,
          workingDays: {
            Mon: schedule.work_days.includes("Mon"),
            Tue: schedule.work_days.includes("Tue"),
            Wed: schedule.work_days.includes("Wed"),
            Thu: schedule.work_days.includes("Thu"),
            Fri: schedule.work_days.includes("Fri"),
            Sat: schedule.work_days.includes("Sat"),
            Sun: schedule.work_days.includes("Sun"),
          },
          startTime: schedule.start_time,
          endTime: schedule.end_time,
          lateIn: schedule.trady_margin.toString(),
          earlyOut: schedule.early_out_margin.toString(),
          overtime: schedule.overtime_margin.toString(),
          numBreaks: schedule.breaks_mints ? schedule.breaks_mints.split(",").length : 0,
          breakMinutes: schedule.breaks_mints ? schedule.breaks_mints.split(",") : [],
          implementation: schedule.type,
          locations: schedule.type === 'location' ? schedule.selected_Ids : [],
          departments: schedule.type === 'department' ? schedule.selected_Ids : [],
          individuals: schedule.type === 'individual' ?  schedule.individuals : [],
        });
        setShowOffcanvas(true);
      } catch (err) {
        alert("Failed to fetch schedule: " + err.message);
      }
    });

    $(tableRef.current).on("click", ".delete-btn", function () {
      const id = $(this).data("id");
      setScheduleToDelete(id);
      setShowDeleteConfirm(true);
    });

    return () => {
      if ($.fn.DataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
    };
  }, [schedules]);

  // Handle Edit Form Changes
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setSelectedSchedule({ ...selectedSchedule, [name]: value });
  };

  const handleEditCheckboxChange = (day) => {
    setSelectedSchedule({
      ...selectedSchedule,
      workingDays: { ...selectedSchedule.workingDays, [day]: !selectedSchedule.workingDays[day] },
    });
  };

  const handleEditBreakChange = (index, value) => {
    const updatedBreaks = [...selectedSchedule.breakMinutes];
    updatedBreaks[index] = value;
    setSelectedSchedule({ ...selectedSchedule, breakMinutes: updatedBreaks });
  };

  const handleEditNumBreaksChange = (num) => {
    const numBreaks = parseInt(num, 10);
    const breakMinutes = Array(numBreaks).fill("");
    setSelectedSchedule({ ...selectedSchedule, numBreaks, breakMinutes });
  };

  const handleEditImplementationChange = (value) => {
    setSelectedSchedule({
      ...selectedSchedule,
      implementation: value,
      locations: [],
      departments: [],
      individuals: [],
    });
  };

  const handleEditSelectionChange = (type, id) => {
    const currentList = selectedSchedule[type];
    const updatedList = currentList.includes(id)
      ? currentList.filter((item) => item !== id)
      : [...currentList, id];
    setSelectedSchedule({ ...selectedSchedule, [type]: updatedList });
  };

  // Handle Save Changes
  const handleSaveChanges = async () => {
    try {
    
      const payload = {
        schedule_name: selectedSchedule.name,
        work_days: Object.keys(selectedSchedule.workingDays)
          .filter((day) => selectedSchedule.workingDays[day])
          .join(","),
        start_time: selectedSchedule.startTime,
        end_time: selectedSchedule.endTime,
        no_of_breaks: selectedSchedule.numBreaks,
        trady_margin: parseInt(selectedSchedule.lateIn, 10),
        early_out_margin: parseInt(selectedSchedule.earlyOut, 10),
        overtime_margin: parseInt(selectedSchedule.overtime, 10),
        breaks_mints: selectedSchedule.breakMinutes.join(","),
        breaks_mints: selectedSchedule.breakMinutes.join(","),
        type: selectedSchedule.implementation,
        selected_Ids:selectedSchedule.implementation === "location" ? selectedSchedule.locations.toString()  : selectedSchedule.implementation === 'department' ? selectedSchedule.departments.toString() : selectedSchedule.implementation === 'individual' ? selectedSchedule.individuals.toString(): '',
    
      };
      
      const response = await axios.put(
        `${API_URL_LOCAL}/api/work-schedule/${selectedSchedule.id}`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.status === 200) {
        setSchedules(
          schedules.map((s) => (s.id === selectedSchedule.id ? { ...s, ...payload } : s))
        );
        setShowOffcanvas(false);
      }
    } catch (err) {
      alert("Failed to update schedule: " + err.message);
    }
  };

  // Handle Delete
  const handleDeleteSchedule = async () => {
    try {
      const response = await axios.delete(
        `${API_URL_LOCAL}/api/work-schedule/${scheduleToDelete}`
      );

      if (response.status === 200) {
        if(schedules.length === 0){
          setSchedules([])
        }else{
          setSchedules(schedules.filter((s) => s.id !== scheduleToDelete));
        }
        setShowDeleteConfirm(false);
        setScheduleToDelete(null);
      }
    } catch (err) {
      alert("Failed to delete schedule: " + err.message);
    }
  };

  return (
    <MasterLayout>
      <Breadcrumb title="Work Schedules" />
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <div className="d-flex justify-content-end mb-20">
            <Link to="/work-schedule/add">
              <Button
                variant="primary"
                className="border border-primary-600 text-md px-24 py-8 radius-8"
              >
                Add New Schedule
              </Button>
            </Link>
          </div>
          {loading && <div className="text-center">Loading...</div>}
          {error && (
            <div className="alert alert-danger bg-danger-50 text-danger-600 border-danger-50 px-24 py-11 mb-20 fw-semibold text-lg radius-8">
              {error}
            </div>
          )}
          {schedules.length !== 0  ? (
            <div className="table-responsive">
              <table
                ref={tableRef}
                className="table table-striped table-bordered"
                style={{ width: "100%" }}
              >
                <thead>
                  <tr>
                    <th>Schedule Name</th>
                    <th>Type</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          ): null }
        </div>
      </div>

      {/* Edit Offcanvas */}
      <Offcanvas show={showOffcanvas} onHide={() => setShowOffcanvas(false)} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Edit Work Schedule</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {selectedSchedule && (
            <Form>
              <Form.Group className="mb-20">
                <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                  Schedule Name <span className="text-danger-600">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={selectedSchedule.name}
                  onChange={handleEditChange}
                  placeholder="Enter Schedule Name"
                  className="radius-8"
                />
              </Form.Group>
              <Form.Group className="mb-20">
                <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                  Select Working Days <span className="text-danger-600">*</span>
                </Form.Label>
                <Row>
                  {Object.keys(selectedSchedule.workingDays).map((day) => (
                    <Col xs={6} md={3} key={day} className="mb-2 check-custom">
                      <Form.Check
                        type="checkbox"
                        label={day}
                        checked={selectedSchedule.workingDays[day]}
                        onChange={() => handleEditCheckboxChange(day)}
                        custom
                        className="form-check-inline check-custom"
                      />
                    </Col>
                  ))}
                </Row>
              </Form.Group>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-20">
                    <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                      Start Time <span className="text-danger-600">*</span>
                    </Form.Label>
                    <Form.Control
                      type="time"
                      name="startTime"
                      value={selectedSchedule.startTime}
                      onChange={handleEditChange}
                      className="radius-8"
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-20">
                    <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                      End Time <span className="text-danger-600">*</span>
                    </Form.Label>
                    <Form.Control
                      type="time"
                      name="endTime"
                      value={selectedSchedule.endTime}
                      onChange={handleEditChange}
                      className="radius-8"
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group className="mb-20">
                <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                  Late In (minutes) <span className="text-danger-600">*</span>
                </Form.Label>
                <Form.Control
                  type="number"
                  name="lateIn"
                  value={selectedSchedule.lateIn}
                  onChange={handleEditChange}
                  placeholder="Enter minutes (e.g., 5)"
                  min="1"
                  max="5"
                  className="radius-8"
                />
              </Form.Group>
              <Form.Group className="mb-20">
                <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                  Early Out (minutes) <span className="text-danger-600">*</span>
                </Form.Label>
                <Form.Control
                  type="number"
                  name="earlyOut"
                  value={selectedSchedule.earlyOut}
                  onChange={handleEditChange}
                  placeholder="Enter minutes (e.g., 5)"
                  min="1"
                  max="5"
                  className="radius-8"
                />
              </Form.Group>
              <Form.Group className="mb-20">
                <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                  Overtime (minutes) <span className="text-danger-600">*</span>
                </Form.Label>
                <Form.Control
                  type="number"
                  name="overtime"
                  value={selectedSchedule.overtime}
                  onChange={handleEditChange}
                  placeholder="Enter minutes (e.g., 5)"
                  min="1"
                  max="5"
                  className="radius-8"
                />
              </Form.Group>
              <Form.Group className="mb-20">
                <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                  Number of Breaks
                </Form.Label>
                <Row>
                  {[1, 2, 3, 4, 5, 6, 7, 8].map((num) => (
                    <Col xs={6} md={3} key={num} className="mb-2 check-custom">
                      <Form.Check
                        type="checkbox"
                        label={num}
                        checked={selectedSchedule.numBreaks === num}
                        onChange={() => handleEditNumBreaksChange(num)}
                        custom
                        className="form-check-inline check-custom"
                      />
                    </Col>
                  ))}
                </Row>
              </Form.Group>
              {selectedSchedule.numBreaks > 0 && (
                <div>
                  <h6 className="mb-20">Break Durations (minutes)</h6>
                  {Array.from({ length: selectedSchedule.numBreaks }).map((_, index) => (
                    <Form.Group key={index} className="mb-20">
                      <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                        Break {index + 1} (minutes) <span className="text-danger-600">*</span>
                      </Form.Label>
                      <Form.Control
                        type="number"
                        value={selectedSchedule.breakMinutes[index] || ""}
                        onChange={(e) => handleEditBreakChange(index, e.target.value)}
                        placeholder="Enter minutes"
                        className="radius-8"
                        min="1"
                      />
                    </Form.Group>
                  ))}
                </div>
              )}
              <Form.Group className="mb-20 check-custom">
                <h6 className="mb-10">Implementation</h6>
                <Form.Check
                  type="radio"
                  label="Location"
                  name="implementation"
                  value="location"
                  checked={selectedSchedule.implementation === "location"}
                  onChange={() => handleEditImplementationChange("location")}
                  className="mb-2"
                />
                {selectedSchedule.implementation === "location" && (
                  <div className="ms-4">
                    {locations.map((loc) => (
                      <Form.Check
                        key={loc.id}
                        type="checkbox"
                        label={loc.title}
                        checked={selectedSchedule.locations.includes(loc.id)}
                        onChange={() => handleEditSelectionChange("locations", loc.id)}
                        className="mb-2"
                      />
                    ))}
                  </div>
                )}
                <Form.Check
                  type="radio"
                  label="Department"
                  name="implementation"
                  value="department"
                  checked={selectedSchedule.implementation === "department"}
                  onChange={() => handleEditImplementationChange("department")}
                  className="mb-2"
                />
                {selectedSchedule.implementation === "department" && (
                  <div className="ms-4">
                    {departments.map((dep) => (
                      <Form.Check
                        key={dep.id}
                        type="checkbox"
                        label={dep.name}
                        checked={selectedSchedule.departments.includes(dep.id)}
                        onChange={() => handleEditSelectionChange("departments", dep.id)}
                        className="mb-2"
                      />
                    ))}
                  </div>
                )}
                <Form.Check
                  type="radio"
                  label="Individual"
                  name="implementation"
                  value="individual"
                  checked={selectedSchedule.implementation === "individual"}
                  onChange={() => handleEditImplementationChange("individual")}
                  className="mb-2"
                />
                {selectedSchedule.implementation === "individual" && (
                  <div className="ms-4">
                    {individuals.map((ind) => (
                      <Form.Check
                        key={ind.id}
                        type="checkbox"
                        label={ind.name}
                        checked={selectedSchedule.individuals.includes(ind.id)}
                        onChange={() => handleEditSelectionChange("individuals", ind.id)}
                        className="mb-2"
                      />
                    ))}
                  </div>
                )}
              </Form.Group>
              <div className="d-flex justify-content-end">
                <Button
                  variant="outline-primary"
                  className="text-md px-24 py-8 radius-8 me-2"
                  onClick={() => setShowOffcanvas(false)}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  className="text-md px-24 py-8 radius-8"
                  onClick={handleSaveChanges}
                >
                  Save Changes
                </Button>
              </div>
            </Form>
          )}
        </Offcanvas.Body>
      </Offcanvas>

      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteConfirm}  style={{marginTop: 80}} onHide={() => setShowDeleteConfirm(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            <h6>Confirm Delete</h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this schedule?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteConfirm(false)}>
            No
          </Button>
          <Button variant="danger" onClick={handleDeleteSchedule}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </MasterLayout>
  );
};

export default WorkSchedulesPage;